/// <reference path="../_references.ts"/>

module App.Customer {
	import Technician = App.Administrative.Inventory.Technician;
	import ServiceRequest = App.Customer.ServiceRequest;
	import ServiceRequestType = App.Appointments.ServiceRequestType;
	import DispatchCode = App.Customer.DispatchCode;
	import PaymentType = App.Payment.PaymentType;
	import LeadSource = App.Appointments.LeadSource;
	import File = App.Appointments.File;

	export class CustomerService {

		constructor(
			public $http: ng.IHttpService,
			public Constants: IConstants
		){}

		public fetch(customerID: number, params?: Object): ng.IHttpPromise<Customer> {
			return this.$http.get(`${this.Constants.apiUrl}customer/${customerID}`, {
				params: params
			});
		}

		public fetchTechnicians(): ng.IHttpPromise<Technician[]> {
			return this.$http.get(`${this.Constants.apiUrl}technician`);
		}

		public fetchDispatchCodes(): ng.IHttpPromise<DispatchCode[]> {
			return this.$http.get(`${this.Constants.apiUrl}dispatchcode`);
		}

		public fetchServiceRequestTypes(): ng.IHttpPromise<ServiceRequestType[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequesttype`);
		}

		public fetchPaymentTypes(): ng.IHttpPromise<PaymentType[]> {
			return this.$http.get(`${this.Constants.apiUrl}paymenttype`);
		}

		public fetchLeadSource(): ng.IHttpPromise<LeadSource[]> {
			return this.$http.get(`${this.Constants.apiUrl}leadsource`);
		}

		public fetchSalesmen(): ng.IHttpPromise<LeadSource[]> {
			return this.$http.get(`${this.Constants.apiUrl}salesman`);
		}

		public fetchCustomerAddress(customerID: number): ng.IHttpPromise<Address[]> {
			return this.$http.get(`${this.Constants.apiUrl}customer/${customerID}/billingaddress`);
		}

		public getServiceAddressList(id: number, params?: Object): ng.IHttpPromise<Address[]> {
			return this.$http.get(`${this.Constants.apiUrl}customer/${id}/serviceaddress`, {
				params: params || {}
			});
		}

		public search(query: string): ng.IHttpPromise<Array<Customer>> {
			return this.$http.get(this.Constants.apiUrl + 'customer', {
				params: {
					query: query
				}
			});
		}

		static factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) =>
				new CustomerService($http, Constants);

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}

		public create(customer: Customer): ng.IHttpPromise<Customer> {
			return this.$http.post(this.Constants.apiUrl + 'customer', customer);
		}

		public createEmail(customerId: number, email: string): ng.IHttpPromise<Email> {
			return this.$http.post(`${this.Constants.apiUrl}customer/${customerId}/email`,
				{
					email: email
				}
			);
		}

		public createPhone(customerId: number, data: { number: string; send_text: boolean }): ng.IHttpPromise<PhoneNumber> {
			return this.$http.post(`${this.Constants.apiUrl}customer/${customerId}/phonenumber`, data);
		}

		public createServiceRequest(sr: ServiceRequest): ng.IHttpPromise<ServiceRequest> {
			const vm = this;

			return vm.$http.post(`${this.Constants.apiUrl}servicerequest`, sr);
		}

		public update(customer: Customer): ng.IHttpPromise<Customer> {
			return this.$http.put(this.Constants.apiUrl + `customer/${customer.id}`, customer);
		}

		public addFile(cId: number, file: File): ng.IHttpPromise<File> {
			return this.$http.post(this.Constants.apiUrl + `customer/${cId}/file`, file);
		}
	}
}
